/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { GetObjectiveQueryResponse, GetObjectivePathParams, GetObjective400, GetObjective401, GetObjective403, GetObjective404, GetObjective409, GetObjective500 } from "../../types/planningTasksController/GetObjective.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getGetObjectiveUrl(organizationId: GetObjectivePathParams["organizationId"], objectiveId: GetObjectivePathParams["objectiveId"]) {
  const res = { method: 'GET', url: `/api/organizations/${organizationId}/objectives/${objectiveId}` as const }
  return res
}

/**
 * @summary Get objective by ID
 * {@link /api/organizations/:organizationId/objectives/:objectiveId}
 */
export async function getObjective(organizationId: GetObjectivePathParams["organizationId"], objectiveId: GetObjectivePathParams["objectiveId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetObjectiveQueryResponse, ResponseErrorConfig<GetObjective400 | GetObjective401 | GetObjective403 | GetObjective404 | GetObjective409 | GetObjective500>, unknown>({ method : "GET", url : getGetObjectiveUrl(organizationId, objectiveId).url.toString(), ... requestConfig })
  return res.data
}